var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"signPage"},[_c('div',{staticClass:"signTitle"},[_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('p',[_vm._v("签名")])],1),_c('Signature_pad',{attrs:{"config":{
  penColor: 'black',
  minWidth:2
}},on:{"receive":_vm.receiveQmValue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }